<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 20px;color:#fff">{{formatType(type).title}}</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">{{formatType(type).value}}</span>
			<div class="inner-btn" @click="changeType">
				{{type=='list'?'添加软件':'返 回'}}
			</div>
		</div>
		<ListSoftware ref="list" v-if="type==='list'" @toEdit="toEdit"></ListSoftware>
		<EditSoftware v-if="type==='edit'" @back="back" :software_id="id"></EditSoftware>
	</div>
</template>

<script>
	import ListSoftware from '../../components/software/ListSoftware.vue'
	import EditSoftware from '../../components/software/EditSoftware.vue'
	let types = {
		list: {
			title: '软件列表',
			value: 'software list'
		},
		add: {
			title: '软件卡密',
			value: 'add software'
		},
		edit: {
			title: '软件卡密',
			value: 'edit software'
		}
	}
	export default {
		components: {
			ListSoftware,
			EditSoftware
		},
		data() {
			return {
				type: 'list',
				id: null
			}
		},
		filters: {
			formatType(value) {
				return types[value]
			}
		},

		methods: {
			formatType(value) {
				return types[value]
			},
			changeType() {
				if (this.type === 'add' || this.type === 'edit') {
					this.type = 'list'
				} else {
					this.$prompt('请输入软件名（不能用中文）', '创建软件', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						inputType: 'text'
					}).then(({
						value
					}) => {
						this.$H.post('/verify_center/v1_0_1.Software/Create',{
							name:value
						}).then(res=>{
							if(res.data){
								this.$message.success('创建成功')
								this.$refs.list.getData()
							}
						})
						
					}).catch(() => {

					});
				}
				console.log(this.type)
			},
			back() {
				this.type = 'list'
				setTimeout(() => {
					this.$refs.list.search()
				}, 500)

			},
			toEdit(id) {
				console.log(12313131323)
				this.id = id
				setTimeout(() => {
					this.type = 'edit'
				}, 500)
				
			}
		}
	}
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 45px 25px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79);
		position: relative;
		color: #e6e6e6;
	}
	.page .container-fluid .inner-btn {
		width: 120px;
		height: 40px;
		border: 1px solid #ccc;
		position: absolute;
		top: 40px;
		right: 20px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor: pointer;
	}
</style>